<section class="not-found-wrapper">
  <div class="container">
    <div
      class="page-not-found d-flex flex-column align-items-center justify-content-center"
    >
      <img 
        src="assets/images/404.svg" 
        alt="" 
        loading="lazy"
        fetchpriority="high"
        />
      <p>{{ "error.page-not-found" | translate }}</p>
      <a class="btn btn-white" routerLink="/">{{
        "buttons.back-to-home" | translate
      }}</a>
    </div>
  </div>
</section>
